const fontFamily = [
	"Poppins",
	"-apple-system",
	"BlinkMacSystemFont",
	'"Segoe UI"',
	'"Helvetica Neue"',
	"Arial",
	"sans-serif",
	'"Apple Color Emoji"',
	'"Segoe UI Emoji"',
	'"Segoe UI Symbol"',
].join(",");

const themeConfig = {
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			lg: 1200,
			xl: 1536,
		},
	},
	palette: {
		body: {
			main: "#ffffff",
			light: "#f5f5f5",
			dark: "#e0e0e0",
			contrastText: "#212121",
		},
		primary: {
			main: "#1e6da7",
			light: "#1e6da7",
			dark: "#1e6da7",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#f2838d",
			light: "#f2838d",
			dark: "#f2838d",
		},
		footer: {
			main: "#1e6da7",
			light: "#1e6da7",
			dark: "#1e6da7",
			contrastText: "#fff",
		},
		colophon: {
			main: "#1e6da7",
			light: "#1e6da7",
			dark: "#1e6da7",
			contrastText: "#fff",
		},
		titleBar: {
			public: {
				main: "#1e6da7",
				light: "#1e6da7",
				dark: "#1e6da7",
				contrastText: "#ffffff",
			},
			private: {
				main: "#1e6da7",
				light: "#1e6da7",
				dark: "#1e6da7",
				contrastText: "#ffffff",
			},
		},
		appBar: {
			public: {
				main: "#ffffff",
				light: "#f5f5f5",
				dark: "#e0e0e0",
				contrastText: "#212121",
			},
			private: {
				main: "#1e6da7",
				light: "#1e6da7",
				dark: "#1e6da7",
				contrastText: "#ffffff",
			},
		},
		link: {
			main: "#3874CB",
		},
		subnav: {
			contrastText: "#757575",
			light: "#E9E9E9",
		},
	},
	typography: {
		fontFamily,
		h1: {
			fontFamily,
			fontSize: "3.2rem",
			fontWeight: 600,
		},
		h2: {
			fontFamily,
		},
		h3: {
			fontFamily,
			fontWeight: 600,
		},
		h4: {
			fontFamily,
			fontWeight: 600,
		},
		h5: {
			fontFamily,
			fontWeight: 600,
		},
		h6: {
			fontFamily,
			fontWeight: 600,
		},
		titleBar: {
			fontFamily,
		},
		nav: {
			fontFamily,
			textTransform: "uppercase",
			fontWeight: 600,
			fontSize: "0.96rem",
		},
		toolsNav: {
			fontFamily,
		},
		subtitle1: {
			fontStyle: "normal",
			fontWeight: 600,
			lineHeight: 1.5,
			letterSpacing: "-0.01562em",
			fontSize: "1.6rem",
		},
	},
	badges: {
		padding: "2px 6px",
		textTransform: "capitalize",
		radius: "6px",
		fontSize: "12px",
	},
	components: {
		MuiButton: {
			styleOverrides: {
				contained: {
					fontWeight: 600,
				},
			},
		},
	},
	cloverleaf: {
		googleFont: "Poppins:ital,wght@0,400;0,600;1,400;1,600",
		css: `
    html.is-home .call-to-action .variant-h1 {
        text-align: left;
        font-size: 4rem;
        max-width: 620px;
    }
    html.is-home .call-to-action .cta-column > .MuiBox-root {
      margin-left: 50%;
    }
    html.is-home .call-to-action > .MuiBox-root {
      background: transparent;
      background-color: rgba(30, 109, 167, 0.6);
    }
    html.is-home .call-to-action {
      border-bottom: 3px solid #f27f89;
    }
    html.is-home #single-body > main .column-section p {
      font-size: 1.5rem;
      color: #1e6da7;
    }
    html.is-home #single-body > main .column-section {
      max-width: 960px;
      padding-top: 4rem;
      padding-bottom: 4rem;
      margin-left: auto;
      margin-right: auto;
    }
    #___gatsby .title-bar {
      text-align: center;
      padding: 1.7rem 0;
      border-bottom: 3px solid #f27f89;
    }
    `,
		inlineImageWidth: "100%",
		labels: {
			filtersTitle: "Filters",
		},
		single: {
			reverseDate: true,
		},
		list: {
			showType: true,
		},
		footer: {
			disableBrand: true,
		},
		navbar: {
			layout: "compact",
			padding: 0.1,
			align: "left",
			gap: 4,
		},
		tags: {
			order: {
				Presenters: 1,
				"Topic domains": 2,
				Constituencies: 3,
				"Geographic foci": 4,
			},
		},
	},
};
module.exports = themeConfig;
